<template>
  <div class="table-action-wrapper import-tracking" ref="container">
    <div class="position-relative d-flex flex-wrap w-100">
      <label for="uploadFile" class="btn btn-outline-success d-flex align-items-center mb-0 mr-2">
        <input id="uploadFile" type="file" @change="changeFile" style="display: none" />
        <span>Choose File</span>
      </label>
      <a @click.prevent="submit" href="#" class="btn btn-outline-success d-flex align-items-center mb-0 mr-2">
        <span>Submit</span>
      </a>
      <a @click.prevent="clear" href="#" class="btn btn-outline-warning d-flex align-items-center mb-0">
        <span>Clear</span>
      </a>
      <small v-if="orders.length == 0" class="w-100">If you don't have the template, please <a @click.prevent="clickDownloadTemplate" href="#">download it here</a>.</small>
      <small v-else class="w-100" v-html="`Waiting for import: ${Object.keys(orders).length} ${Object.keys(orders).length > 1 ? 'orders' : 'order'}`"></small>
    </div>
  </div>
</template>
<script>
import { read, utils, writeFileXLSX } from 'xlsx'
export default {
  data() {
    return {
      cols: [
        { label: 'Order ID', required: 1 },
        { label: 'Name', required: 1 },
        { label: 'Email', required: 0 },
        { label: 'Phone', required: 0 },
        { label: 'First Line', required: 1 },
        { label: 'Second Line', required: 0 },
        { label: 'City', required: 1 },
        { label: 'State', required: 1 },
        { label: 'Country', required: 1 },
        { label: 'Zip', required: 1 },
        { label: 'Note', required: 0 },
        { label: 'Total Price', required: 1 },
        { label: 'Currency', required: 1 },
        { label: 'Created At', required: 0 },
        { label: 'Account ID', required: 1 },
        { label: 'Line Item / ID', required: 1 },
        { label: 'Line Item / SKU', required: 0 },
        { label: 'Line Item / Title', required: 1 },
        { label: 'Line Item / Thumbnail', required: 1 },
        { label: 'Line Item / Quantity', required: 1 },
        { label: 'Line Item / Category', required: 0 },
        { label: 'Line Item / Price', required: 1 },
        { label: 'Line Item / Note', required: 0 },
        { label: 'Line Item / Attributes', required: 0 }
      ],
      indexCols: {},
      orders: []
    }
  },
  computed: {
    store() {
      return this.config?.store
    }
  },
  methods: {
    async changeFile(e) {
      const file = e.target.files[0]
      let cols = []
      if (!/\.(xlsx|xls)$/i.test(file.name)) {
        alert('Only xlsx format is supported')
        return
      }
      let wb = read(await file.arrayBuffer())
      let data = utils.sheet_to_json(wb.Sheets[wb.SheetNames[0]], { header: 1 })
      cols.push(data.shift())
      cols.push(data.shift())
      this.orders = []
      let order = {},
        rawOrder,
        lineItem
      for (let i = 0; i <= data.length; i++) {
        rawOrder = {
          id: this.cellData(data[i], 'Order ID'),
          name: this.cellData(data[i], 'Name'),
          email: this.cellData(data[i], 'Email'),
          phone: this.cellData(data[i], 'Phone'),
          first_line: this.cellData(data[i], 'First Line'),
          second_line: this.cellData(data[i], 'Second Line'),
          city: this.cellData(data[i], 'City'),
          state: this.cellData(data[i], 'State'),
          zip: this.cellData(data[i], 'Zip'),
          country: this.cellData(data[i], 'Country'),
          note: this.cellData(data[i], 'Note'),
          price: this.cellData(data[i], 'Total Price'),
          currency: this.cellData(data[i], 'Currency'),
          created_at: this.cellData(data[i], 'Created At'),
          account_id: this.cellData(data[i], 'Account ID'),
          line_items: []
        }

        let attributes = {}
        for (let productIndex = this.colToIndex('Line Item / Attributes'); productIndex < cols[1].length; productIndex++) {
          attributes[cols[1][productIndex]] = data[i]?.[productIndex] || null
        }

        lineItem = {
          id: this.cellData(data[i], 'Line Item / ID'),
          sku: this.cellData(data[i], 'Line Item / SKU'),
          title: this.cellData(data[i], 'Line Item / Title'),
          thumbnail: this.cellData(data[i], 'Line Item / Thumbnail'),
          quantity: this.cellData(data[i], 'Line Item / Quantity'),
          category: this.cellData(data[i], 'Line Item / Category'),
          price: this.cellData(data[i], 'Line Item / Price'),
          note: this.cellData(data[i], 'Line Item / Note')
        }
        if (Object.values(lineItem).join('') != '') {
          lineItem.attributes = attributes
        } else if (data[i] != undefined) {
          continue
        }

        if (data[i] != undefined && Object.values(rawOrder).join('') == '') {
          order.line_items.push(lineItem)
        } else {
          if (Object.values(order).join('') != '') {
            this.orders.push(order)
          }
          order = rawOrder
          order.line_items.push(lineItem)
        }
      }
      e.target.value = ''
    },
    clickDownloadTemplate() {
      let workbook = utils.book_new()
      let worksheet = utils.aoa_to_sheet([
        this.cols.map((item) => {
          return `${item.label}${item.required ? '*' : ''}`
        }),
        new Array(this.colToIndex('Line Item / Attributes')).fill('').concat(['Size', 'Color', 'Style'])
      ])
      utils.book_append_sheet(workbook, worksheet, 'Order')
      writeFileXLSX(workbook, `Order-${new Date().getTime()}.xlsx`)
    },
    colToIndex(str) {
      if (Object.keys(this.indexCols).length == 0) {
        this.cols.forEach((item, index) => {
          this.indexCols[item.label] = index
        })
      }
      return this.indexCols[str] ?? null
    },
    cellData(row, col) {
      return String(row?.[this.colToIndex(col)] || '')
    },
    clear() {
      this.orders = []
    },
    submit() {
      this.$util
        .post(
          '/order/more/import-orders',
          {
            orders: this.orders
          },
          this.$refs.container
        )
        .then((response) => {
          if (response.status == 'success') {
            this.clear()
          }
        })
    }
  },
  props: {
    config: Object
  }
}
</script>

<style lang="scss">
.import-tracking {
  .thumbnail-preview-wrapper {
    width: calc(50% - 10px);
    display: flex;
    flex-wrap: wrap;
    border: 1px solid transparent;
    border-radius: var(--border-radius, 0.25rem);
    margin: 5px;
    .right-content {
      p {
        margin: 0;
      }
    }
  }
  .thumbnail-preview-inner {
    width: 80px !important;
  }
  .thumbnail-preview-wrapper {
    &.ignore,
    &.success {
      color: #1e6641;
      background-color: #c8eedb;
    }
    &.error {
      color: #71132a;
      background-color: #f4c2ce;
    }
  }
  .list-tracking {
    max-height: 500px;
    overflow: auto;
    p {
      margin-bottom: 0;
    }
    li {
      padding: 5px;
      > div {
        padding: 5px 15px;
        border-radius: var(--border-radius, 0.25rem);
      }
      &.error > div {
        background: #ffecec;
        border: 1px solid #f5aca6;
      }
      &.success > div {
        background: #e9ffd9;
        border: 1px solid #a6ca8a;
      }
      &.warning > div {
        background: #fff8c4;
        border: 1px solid #f2c779;
      }
      &.ignore > div,
      &.notice > div {
        background: #e3f7fc;
        border: 1px solid #8ed9f6;
      }
    }
  }
}
</style>
